module.exports={
	"Form": "UserRoleJoinEditManifest",
	"Scope": "UserRoleJoin-Edit",
	"Descriptors":
	{
		"UserRoleJoinDetails.IDUserRoleJoin":
		{
			"Name": "ID",
			"Hash": "URJEdit-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "URJEditIdentity",
				"Group": "URJEditIdentity"
			}
		},
		"UserRoleJoinDetails.GUIDUserRoleJoin":
		{
			"Name": "GUID",
			"Hash": "URJEdit-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "URJEditIdentity",
				"Group": "URJEditIdentity"
			}
		},
		"UserRoleJoinDetails.IDUser":
		{
			"Name": "User ID",
			"Hash": "URJEdit-IDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "1",
				"Width": 3,
				"Section": "URJEditIdentity",
				"Group": "URJEditIdentity"
			}
		},
		"UserRoleJoinDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "URJEdit-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "1",
				"Width": 3,
				"Section": "URJEditIdentity",
				"Group": "URJEditIdentity"
			}
		},
		"UserRoleJoinDetails.ProxyIDRole":
		{
			"Name": "Proxy Role ID",
			"Hash": "URJEdit-ProxyIDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "Number",
				"Row": "2",
				"Width": 3,
				"Section": "URJEditConfig",
				"Group": "URJEditConfig"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Assignment",
			"Hash": "URJEditIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Assignment",
					"Hash": "URJEditIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Proxy Configuration",
			"Hash": "URJEditConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Proxy Configuration",
					"Hash": "URJEditConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
